import { render, staticRenderFns } from "./EditorView.vue?vue&type=template&id=b1bb3198&scoped=true&"
import script from "./EditorView.vue?vue&type=script&lang=js&"
export * from "./EditorView.vue?vue&type=script&lang=js&"
import style0 from "./EditorView.vue?vue&type=style&index=0&id=b1bb3198&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bb3198",
  null
  
)

export default component.exports